import type { LeadsSearchRow } from "app/pages/sales-intelligence/modules/leads-search";
import { getLeadDomainFromRow } from "app/pages/sales-intelligence/sub-modules/company-search/helpers/rows";
import {
    COLUMN_NEWS_NAME,
    COLUMN_SIGNALS_NAME,
} from "app/pages/sales-intelligence/sub-modules/signals/constants/column-names";

export const createTooltipId = <R extends LeadsSearchRow>(tableRow: R): string => {
    return `${getLeadDomainFromRow(tableRow)}-signals-tooltip`;
};

export const getSignalsCountFromRow = (row: LeadsSearchRow): number => {
    const newsTitles = row[COLUMN_NEWS_NAME] ?? [];
    const signalsIds = row[COLUMN_SIGNALS_NAME] ?? [];

    return newsTitles.length + signalsIds.length;
};
